/**
 * Site Module
 */

import Axios from 'axios'
import LoadedDataValidity from '../../classes/LoadedDataValidity.js'
import dataExpirationTimes from '../../constant/dataExpirationTimes.js'

const basicCheckoutDataValidity = new LoadedDataValidity(dataExpirationTimes.TWO_MIN)
const cartEditDataValidity = new LoadedDataValidity(dataExpirationTimes.TWO_MIN)
const cartAddressDataValidity = new LoadedDataValidity(dataExpirationTimes.TWO_MIN)
const cartPaymentShipmentDataValidity = new LoadedDataValidity(dataExpirationTimes.TWO_MIN)

const state = {
  /**
   * cart alap adatok, pl üres-e a kosár, kosár item darabszám, összeg, stb
   *
   * @type {
   *  ?{
   *   cartItemCount: Number,
   *   cartTotalSum: String,
   *   hasCartHeader: Boolean,
   *   isCartEmpty: Boolean,
   *   isCatalogSite: Boolean,
   *   shippingPrice: String,
   *   shippingPriceSecondary: String|null,
   *   shippingHandlingFeeTitle: String,
   *   shippingHandlingFee: Number,
   *   cartTotalSumSecondary: String|null,
   *   shippingType: String,
   *   showWarningText: Boolean,
   *   warningText: String,
   *  }
   * }
   */
  basicCheckoutData: null,
  /**
   * kosár temékek, couponok, ehhez kapcsolod adatok
   *
   * @type {
   *  ?{
   *    canUseCoupon: Boolean,
   *    cartHeaderFound: Boolean,
   *    cartItemCount: Number,
   *    cartItemList: [
   *      {
   *        colorCode: String,
   *        assemblyPrice: String,
   *        brandName: String,
   *        color: String,
   *        dataLayerItemData: [
   *          {
   *            index: Number,
   *            item_brand: String,
   *            item_category: String,
   *            item_category_2: String,
   *            item_category_3: String,
   *            item_category_4: String,
   *            item_color: String,
   *            item_flavor: String,
   *            item_id: String,
   *            item_ifs_number: String,
   *            item_name: String,
   *            item_size: String,
   *            item_variant: String,
   *            price: Number,
   *            quantity: Number,
   *          },
   *        ],
   *        defaultAssemblyPrice: String,
   *        flavor: String,
   *        flavorCode: String,
   *        gifts: [],
   *        hasAssembly: Boolean,
   *        hasGifts: Boolean,
   *        hasSpecShipping: Boolean,
   *        id: Number,
   *        imgSrc: String,
   *        isDiscounted: Boolean,
   *        isItemPackage: Boolean,
   *        itemId: Number,
   *        itemName: String,
   *        needAssembly: Boolean,
   *        needModifyButton: Boolean,
   *        other: String,
   *        packaging: String,
   *        price: String,
   *        priceSecondaryFormatted: String|null,
   *        priceWithQuantitySecondaryFormatted: String|null,
   *        priceWithQuantity: String,
   *        quantity: Number,
   *        sapGroupCode: Number,
   *        hasLoginPrice: Boolean,
   *        size: String,
   *        sizeCode: String,
   *        specShippingPrice: String,
   *        stockInfo: {
   *          inStock: Number,
   *          msg: String,
   *        },
   *        unitPrice: String,
   *        loginPriceFormatted: String,
   *      },
   *    ],
   *    cartItemPriceSum: String,
   *    cartItemQuantityMax: String,
   *    coupon: {},
   *    currentCouponCode: String,
   *    dailyGift: {
   *      hasDailyGift: Boolean,
   *      hasDailyGiftNext: Boolean,
   *      gift: Array,
   *      giftNext: Array,
   *      giftHtml: String,
   *    },
   *    dataLayerItemData: [
   *      {
   *        index: Number,
   *        item_brand: String,
   *        item_category: String,
   *        item_category_2: String,
   *        item_category_3: String,
   *        item_category_4: String,
   *        item_color: String,
   *        item_flavor: String,
   *        item_id: String,
   *        item_ifs_number: String,
   *        item_list_id: String,
   *        item_list_name: String,
   *        item_name: String,
   *        item_size: String,
   *        item_variant: String,
   *        price: Number,
   *        quantity: Number,
   *      },
   *    ],
   *    hasValidCouponCode: Boolean,
   *    isUsingPoints: Boolean,
   *    savedCartEmail: String,
   *    usedGiftPointValue: ?String,
   *    usedGiftPointValueSecondaryFormatted: String|null,
   *    userDiscountData: {
   *      selectedDiscountTab: String,
   *      availableDiscountTabs: {
   *        point: Boolean,
   *        coupon: Boolean,
   *      },
   *      giftPoint: Number,
   *    },
   *  }|null
   * }
   */
  cartEditData: null,
  /**
   * kosár fejléchez tartozo address adatok
   *
   * @type {
   *  ?{
   *    address: String,
   *    addressBill: String,
   *    cartHeaderFound: Boolean,
   *    city: String,
   *    cityBill: String,
   *    email: String,
   *    emailSuggestionDictionary: {
   *      domains: [String,],
   *      secondLevelDomains: [String,],
   *      topLevelDomains: [String,],
   *    },
   *    firstName: String,
   *    fullName: String,
   *    isBilledCheckoutEnabled: Boolean,
   *    isEmailBlocked: Boolean,
   *    isFirstNameFirst: Boolean,
   *    isIndividualPerson: Boolean,
   *    lastName: String,
   *    phoneNumber: String,
   *    shipDifferFromBill: Boolean,
   *    useEmailSuggestion: Boolean,
   *    vatNumber: String,
   *    zipCode: String,
   *    zipCodeBill: String,
   *  }
   * }
   */
  cartAddressData: null,
  /**
   * checkout és header cart által használt szállitási, fizetési, módok, ország stb
   *
   * @typedef{
   *  {
   *    cartHeaderFound: Boolean,
   *    citiesOptions: [],
   *    destinationOptions: [{code: "AT", label: "Ausztria"}, {code: "BE", label: "Belgium"},…],
   *    isGlsPoint: Boolean,
   *    isShopPoint: Boolean,
   *    paymentMethodOptions: [{code: "cash", label: "Utánvét (készpénz a helyszínen)"},…],
   *    selectedCity: [],
   *    selectedDestination: {code: "HU", label: "Magyarország"},
   *    selectedPaymentMethod: {code: "cib", label: "OnLine bankkártyás"},
   *    selectedShippingMethod: {code: "gls", label: "GLS Futár"},
   *    selectedShop: [],
   *    shippingMethodOptions: [{code: "gls", label: "GLS Futár"}, {code: "szeged", label: "szem.átv.Szegeden"},…],
   *    shopOptions: [],
   *    foxpostSelectOptions: [{
   *      label: string,
   *      code: string,
   *      districtList: [{
   *        label: string,
   *        code: string,
   *        addressList: [{
   *          label: string,
   *          code: string,
   *          operatorId: string,
   *          address: string,
   *          name: string,
   *        },]
   *      },],
   *      addressList: [{
   *        label: string,
   *        code: string,
   *        operatorId: string,
   *        address: string,
   *        name: string,
   *      },]
   *    },],
   *  }
   * }
   */
  cartPaymentShipmentData: null,
  /**
   * basic checkout data load kész-e
   */
  isBasicCheckoutDataLoaded: false,
  /**
   * cart edit data load kész-e
   */
  isCartEditDataLoaded: false,
  /**
   * cart address data load kész-e
   */
  isCartAddressDataLoaded: false,
  /**
   * cart paxment shipment data load kész-e
   */
  isCartPaymentShipmentDataLoaded: false,
}

const getters = {
  /**
   * basicCheckoutData getter
   *
   * @param state
   * @returns {null}
   */
  getBasicCheckoutData: state => {
    return state.basicCheckoutData
  },
  /**
   * cartEditData getter
   *
   * @param state
   * @returns {null}
   */
  getCartEditData: state => {
    return state.cartEditData
  },
  /**
   * cartitem lista
   *
   * @param state
   * @return {*|boolean}
   */
  getCartItemList: state => {
    return state.cartEditData ? state.cartEditData.cartItemList : []
  },
  /**
   * cartAddressData getter
   *
   * @param state
   * @returns {null}
   */
  getCartAddressData: state => {
    return state.cartAddressData
  },
  /**
   * cartPaymentShipmentData getter
   *
   * @param state
   * @returns {null}
   */
  getCartPaymentShipmentData: state => {
    return state.cartPaymentShipmentData
  },
  /**
   * basic checkout adatok betöltődtek-e
   *
   * @param state
   * @return {boolean}
   */
  getIsBasicCheckoutDataLoaded: state => {
    return state.isBasicCheckoutDataLoaded
  },
  /**
   * cart edit adatok betöltődtek-e
   *
   * @param state
   * @return {boolean}
   */
  getIsCartEditDataLoaded: state => {
    return state.isCartEditDataLoaded
  },
  /**
   * cart address adatok betöltődtek-e
   *
   * @param state
   * @return {boolean}
   */
  getIsCartAddressDataLoaded: state => {
    return state.isCartAddressDataLoaded
  },
  /**
   * fizetés és szállítas adatok load kész van-e
   *
   * @param state
   * @return {boolean}
   */
  getIsCartPaymentShipmentDataLoaded: state => {
    return state.isCartPaymentShipmentDataLoaded
  },
  /**
   * kosár fejléc létezik-e a usernek
   *
   * @param state
   * @return {*|boolean}
   */
  getIsCartHeaderExists: state => {
    return state.basicCheckoutData !== null ? state.basicCheckoutData.hasCartHeader : false
  },
}

const actions = {
  init({ dispatch }) {
    return Promise.all([
      dispatch('getBasicCheckoutData'),
      dispatch('getCartEditData'),
      dispatch('getCartAddressData'),
    ])
  },
  /**
   * adatok betöltődtek-e flagek reset login vagy logout utáni hivásra
   */
  resetDataLoadedFlags({ commit }) {
    commit('setIsBasicCheckoutDataLoaded', false)
    commit('setIsCartEditDataLoaded', false)
    commit('setIsCartAddressDataLoaded', false)
  },
  /**
   * aktív kupon törlése
   */
  removeAppliedCoupon() {
    return Axios.get('Shop/api/removeAppliedCoupon')
      .then(() => {
      })
      .catch((e) => {
        console.error('removeAppliedCoupon', e)
      })
  },
  /**
   * napi ajándék frissitése
   */
  refreshDailyGift() {
    Axios.get('Shop/api/refreshDailyGift')
      .then(({ data }) => {
        state.cartEditData.dailyGift = data.dailyGift
      })
      .catch((e) => {
        console.error('refreshDailyGift', e)
      })
  },
  /**
   * basic checkout data betöltése
   *
   * @param commit
   * @param forceRefresh
   * @return {Promise<void>|Promise<AxiosResponse<any>>}
   */
  getBasicCheckoutData({ commit }, forceRefresh = false) {
    if (!forceRefresh && state.basicCheckoutData !== null && basicCheckoutDataValidity.isUpToDate()) {
      return Promise.resolve()
    }
    return Axios.get('Shop/api/getBasicCheckoutData')
      .then(({ data }) => {
        commit('setBasicCheckoutData', data)
        basicCheckoutDataValidity.setDateToInspect()
      })
      .catch((error) => {
        basicCheckoutDataValidity.resetDateToInspect()
        commit('setBasicCheckoutData', null)
        console.error(error)
      })
      .finally(() => {
        commit('setIsBasicCheckoutDataLoaded', true)
      })
  },
  /**
   * cart edit componens számára szükséges adatok lekérése
   *
   * @param commit
   * @param forceRefresh
   * @return {Promise<void>|Promise<AxiosResponse<any>>}
   */
  getCartEditData({ commit }, forceRefresh = false) {
    if (!forceRefresh && state.cartEditData !== null && cartEditDataValidity.isUpToDate()) {
      return Promise.resolve()
    }
    return Axios.get('Shop/api/getCartEditData')
      .then(({ data }) => {
        if (data.cartHeaderFound) {
          commit('setCartEditData', data)
        } else {
          commit('setCartEditData', null)
        }
        cartEditDataValidity.setDateToInspect()
      })
      .catch((error) => {
        cartEditDataValidity.resetDateToInspect()
        commit('setCartEditData', null)
        console.error(error)
      })
      .finally(() => {
        commit('setIsCartEditDataLoaded', true)
      })
  },
  /**
   * cart address componens számára szükséges adatok lekérése
   *
   * @param commit
   * @param forceRefresh
   * @return {Promise<void>|Promise<AxiosResponse<any>>}
   */
  getCartAddressData({ commit }, forceRefresh = false) {
    if (!forceRefresh && state.cartAddressData !== null && cartAddressDataValidity.isUpToDate()) {
      return Promise.resolve()
    }
    return Axios.get('Shop/api/getCartAddressData')
      .then(({ data }) => {
        if (data.cartHeaderFound) {
          commit('setCartAddressData', data)
        } else {
          commit('setCartAddressData', null)
        }
        cartAddressDataValidity.setDateToInspect()
      })
      .catch((error) => {
        cartAddressDataValidity.resetDateToInspect()
        commit('setCartAddressData', null)
        console.error(error)
      })
      .finally(() => {
        commit('setIsCartAddressDataLoaded', true)
      })
  },
  /**
   * cart ország, szállitás, fizetés opciok
   *
   * @param commit
   * @param forceRefresh
   * @return {Promise<void>|Promise<AxiosResponse<any>>}
   */
  loadCartPaymentShipmentData({ commit }, forceRefresh = false) {
    if (!forceRefresh && state.cartPaymentShipmentData !== null && cartPaymentShipmentDataValidity.isUpToDate()) {
      return Promise.resolve()
    }
    return Axios.get('Shop/api/getCartPaymentShipmentData')
      .then(({ data }) => {
        commit('setCartPaymentShipmentData', data)
        cartPaymentShipmentDataValidity.setDateToInspect()
      })
      .catch((error) => {
        cartPaymentShipmentDataValidity.resetDateToInspect()
        commit('setCartPaymentShipmentData', null)
        console.error(error)
      })
      .finally(() => {
        commit('setIsCartPaymentShipmentDataLoaded', true)
      })
  },
}

const mutations = {
  /**
   * @param state
   * @param payload
   */
  setBasicCheckoutData(state, payload) {
    state.basicCheckoutData = payload
  },
  /**
   * @param state
   * @param payload
   */
  setCartEditData(state, payload) {
    state.cartEditData = payload
  },
  /**
   * @param state
   * @param payload
   */
  setCartAddressData(state, payload) {
    state.cartAddressData = payload
  },
  /**
   * @param state
   * @param payload
   */
  setCartPaymentShipmentData(state, payload) {
    state.cartPaymentShipmentData = payload
  },
  /**
   * @param state
   * @param payload
   */
  setIsBasicCheckoutDataLoaded(state, payload) {
    state.isBasicCheckoutDataLoaded = payload
  },
  /**
   * @param state
   * @param payload
   */
  setIsCartEditDataLoaded(state, payload) {
    state.isCartEditDataLoaded = payload
  },
  /**
   * @param state
   * @param payload
   */
  setIsCartAddressDataLoaded(state, payload) {
    state.isCartAddressDataLoaded = payload
  },
  /**
   * @param state
   * @param payload
   */
  setIsCartPaymentShipmentDataLoaded(state, payload) {
    state.isCartPaymentShipmentDataLoaded = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
